<template>
  <div class="scaffold">
    <md-app md-waterfall md-mode="fixed">
      <md-app-drawer
        :md-active.sync="menuVisible"
        md-permanent="full"
        :class="{ collapsed: menuCollapsed }"
      >
        <md-toolbar
          slot="reference"
          class="md-transparent avatar-top"
          md-elevation="0"
          style="display: flex; align-items: center; flex-wrap: nowrap"
        >
          <div
            v-if="!menuCollapsed"
            class="avatar"
            @click="goToHome()"
            style="cursor: pointer; flex-shrink: 0"
          >
            <img
              :src="
                (profile?.school?.logo ||
                  profile?.group?.logo ||
                  profile.avatar) | media
              "
              alt="AVATAR"
            />
          </div>
          <div
            class="main"
            v-if="!menuCollapsed"
            style="
              flex: 1;
              white-space: normal;
              word-break: break-word;
              min-width: 0;
              padding: 0 4px;
            "
          >
            {{ profile?.school?.name || profile?.group?.name }}
          </div>
          <md-button
            class="md-icon-button menu-toggle"
            @click="menuCollapsed = !menuCollapsed"
            style="
              flex-shrink: 0;
              margin-left: 0;
              background-color: #00000010;
              display: flex !important;
              align-items: center;
              justify-content: center;
            "
          >
            <md-icon
              style="
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                left: 2px;
              "
              >{{ menuCollapsed ? 'chevron_right' : 'chevron_left' }}</md-icon
            >
          </md-button>
        </md-toolbar>
        <md-list class="list-container" :class="{ collapsed: menuCollapsed }">
          <md-list-item :class="isActive('Home')" @click.prevent="open('Home')">
            <md-tooltip md-direction="right">{{ $t('MENU_HOME') }}</md-tooltip>
            <div class="active-bar" />
            <div class="nav-item">
              <i class="md-svg-loader md-icon md-icon-image md-theme-default">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M16.19 2H12.75V8V8.75V13.75H22V8.75V8V7.81C22 4.17 19.83 2 16.19 2Z"
                    fill="black"
                    fill-opacity="0.5"
                  />
                  <path
                    d="M2 10.25V15.25V15.75V16.19C2 19.83 4.17 22 7.81 22H11.25V15.75V15.25V10.25H2Z"
                    fill="black"
                    fill-opacity="0.5"
                  />
                  <path
                    d="M11.25 2V8.75H2V7.81C2 4.17 4.17 2 7.81 2H11.25Z"
                    fill="black"
                    fill-opacity="0.5"
                  />
                  <path
                    d="M22 15.25V16.19C22 19.83 19.83 22 16.19 22H12.75V15.25H22Z"
                    fill="black"
                    fill-opacity="0.5"
                  />
                </svg>
              </i>
            </div>
            <div class="nav-item-text" v-if="!menuCollapsed">
              {{ $t('MENU_HOME') }}
            </div>
          </md-list-item>

          <!-- <md-list-item
            v-if="profile && ((profile.schoolId && (profile.roles.includes('super_admin') || profile.roles.includes('admin')) || profile.roles.includes('group_chief') || profile.roles.includes('department_chief')))"
            :class="isActive('School')"
            to="/truong-hoc/teachers"
          >
            <md-tooltip md-direction="right">{{ $t('MENU_SCHOOL') }}</md-tooltip>
            <div class="active-bar" />
            <div class="nav-item">
              <i class="md-svg-loader md-icon md-icon-image md-theme-default">
                <svg xmlns="http://www.w3.org/2000/svg" width="35" height="33.913" viewBox="0 0 35 33.913"><g class="a" transform="translate(-3.334 -71.2)"><path d="M92.824,88.625a.558.558,0,0,0-.035-.085q-.969-1.984-1.938-3.973c-.092-.192-.185-.381-.281-.573a.575.575,0,0,0-.5-.285H84.583a.586.586,0,0,0-.577.577v18.306c0,.454-.012.9-.008,1.358H82.852V85.218c0-.885.023-1.777,0-2.661v-.073a.608.608,0,0,0-.265-.45h0c-.746-.6-1.492-1.2-2.234-1.792l-3.723-2.984c-.227-.185-.458-.365-.685-.55v-.985h3.8a.547.547,0,0,0,.173-.031.6.6,0,0,0,.312-.238.513.513,0,0,0,.092-.312.57.57,0,0,0-.05-.215v0c-.008-.023-.019-.046-.027-.069-.215-.465-.431-.931-.65-1.392.215-.465.431-.931.65-1.392a.585.585,0,0,0-.5-.869H75.36a.085.085,0,0,0-.031,0,.065.065,0,0,0-.027,0h-.027a.091.091,0,0,0-.031.008l-.05.012-.035.012h0l-.023.012-.027.012-.023.012s-.008,0-.012.008-.008,0-.012.008-.015.012-.023.015a.476.476,0,0,0-.085.069l-.019.019s0,.008-.008.012a.211.211,0,0,0-.027.035h0a.582.582,0,0,0-.115.285c0,.019,0,.038,0,.058v4.93q-.848.681-1.7,1.358l-3.4,2.727c-.415.335-.831.665-1.246,1-.258.208-.55.365-.577.735-.027.4,0,.819,0,1.223v19.075c0,.377,0,.758,0,1.135h-1.15v-13.2c0-.635.019-1.273,0-1.908V84.283a.586.586,0,0,0-.577-.577H60.65a.508.508,0,0,0-.15.023s-.008,0-.015,0a.618.618,0,0,0-.335.258,0,0,0,0,1,0,0c-.015.035-.035.069-.05.1q-.946,1.938-1.888,3.873c-.092.192-.185.385-.281.573a.584.584,0,0,0,.5.869h.9v13.184c0,.45-.012.9-.008,1.354-.146,0-.292,0-.438,0h-.058a.581.581,0,0,0-.577.577.589.589,0,0,0,.577.577H80.564c.558,0,1.123.019,1.681,0h8.3c.427,0,.858.008,1.285,0h.058a.581.581,0,0,0,.577-.577.589.589,0,0,0-.577-.577h-.5V90.768c0-.454.012-.908.008-1.358h.892a.508.508,0,0,0,.15-.023.014.014,0,0,0,.012,0,.6.6,0,0,0,.308-.223s.008-.012.012-.015h0A.564.564,0,0,0,92.824,88.625ZM63.653,100.871a.577.577,0,1,1-1.154,0V98.69a.589.589,0,0,1,.577-.577.581.581,0,0,1,.577.577Zm0-6.449a.577.577,0,1,1-1.154,0V92.241a.577.577,0,1,1,1.154,0ZM73.791,83.91a2.089,2.089,0,0,1,2.242-.611,2.113,2.113,0,0,1,1.411,1.927h0v.085h0a2.079,2.079,0,1,1-3.654-1.4ZM72.007,92.2a.589.589,0,0,1,.577-.577.581.581,0,0,1,.577.577v2.181a.577.577,0,1,1-1.154,0Zm6.711,6.142v5.611H72.007V98.3a.586.586,0,0,1,.577-.577h5.557a.581.581,0,0,1,.577.577Zm0-3.961a.577.577,0,1,1-1.154,0V92.2a.589.589,0,0,1,.577-.577.581.581,0,0,1,.577.577Zm9.515,6.492a.577.577,0,1,1-1.154,0V98.69a.589.589,0,0,1,.577-.577.581.581,0,0,1,.577.577Zm0-6.492a.577.577,0,1,1-1.154,0V92.2a.589.589,0,0,1,.577-.577.581.581,0,0,1,.577.577Z" transform="translate(-54.526 0)"></path></g></svg>
              </i>
            </div>
            <div class="nav-item-text">{{ $t('MENU_SCHOOL') }}</div>
          </md-list-item> -->
          <div class="expand-menu">
            <div class="expand-menu-title" v-if="!menuCollapsed">
              {{ $t('MENU_TRAINNING') }}
            </div>
          </div>
          <md-list-item
            v-if="!hasCenterItem('V2CenterClasses')"
            :class="isActive('Class')"
            @click.prevent="open('Class')"
          >
            <md-tooltip md-direction="right">{{ $t('MENU_CLASS') }}</md-tooltip>
            <div class="active-bar" />
            <div class="nav-item">
              <i class="md-svg-loader md-icon md-icon-image md-theme-default">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M19 17C20.6569 17 22 15.6569 22 14V5C22 3.34315 20.6569 2 19 2H5C3.34315 2 2 3.34315 2 5V14C2 15.6569 3.34314 17 5 17H6.52542L4.35687 20.6142C4.14376 20.9694 4.25893 21.4301 4.61412 21.6432C4.9693 21.8563 5.43 21.7412 5.64311 21.386L8.2747 17H11.25V19.0001C11.25 19.4143 11.5858 19.7501 12 19.7501C12.4142 19.7501 12.75 19.4143 12.75 19.0001V17H15.7253L18.3569 21.386C18.57 21.7412 19.0307 21.8563 19.3859 21.6432C19.741 21.4301 19.8562 20.9694 19.6431 20.6142L17.4746 17H19ZM6.25 7C6.25 6.58579 6.58579 6.25 7 6.25H17C17.4142 6.25 17.75 6.58579 17.75 7C17.75 7.41421 17.4142 7.75 17 7.75H7C6.58579 7.75 6.25 7.41421 6.25 7ZM7 11.25C6.58579 11.25 6.25 11.5858 6.25 12C6.25 12.4142 6.58579 12.75 7 12.75H12C12.4142 12.75 12.75 12.4142 12.75 12C12.75 11.5858 12.4142 11.25 12 11.25H7Z"
                    fill="black"
                    fill-opacity="0.5"
                  />
                </svg>
              </i>
            </div>
            <div class="nav-item-text" v-if="!menuCollapsed">
              {{ $t('MENU_CLASS') }}
            </div>
          </md-list-item>

          <!-- Center training pages (v2) take the place of the LMS Lớp học / Học sinh. -->
          <md-list-item
            v-for="item in centerTrainingItems"
            :key="'ci-' + item.name"
            :class="centerItemClass(item.name)"
            @click.prevent="open(item.name)"
          >
            <md-tooltip md-direction="right">{{ $t(item.labelKey) }}</md-tooltip>
            <div class="active-bar" />
            <div class="nav-item">
              <i class="md-svg-loader md-icon md-icon-image md-theme-default">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path :d="item.icon" fill="black" fill-opacity="0.5" />
                </svg>
              </i>
            </div>
            <div class="nav-item-text" v-if="!menuCollapsed">
              {{ $t(item.labelKey) }}
            </div>
          </md-list-item>

          <md-list-item
            v-if="!hasCenterItem('V2CenterStudents')"
            :class="isActive('Students')"
            @click.prevent="open('Students')"
          >
            <md-tooltip md-direction="right">{{
              $t('MENU_STUDENT')
            }}</md-tooltip>
            <div class="active-bar" />
            <div class="nav-item">
              <i class="md-svg-loader md-icon md-icon-image md-theme-default">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M17.53 7.77C17.46 7.76 17.39 7.76 17.32 7.77C15.77 7.72 14.54 6.45 14.54 4.89C14.54 3.3 15.83 2 17.43 2C19.02 2 20.32 3.29 20.32 4.89C20.31 6.45 19.08 7.72 17.53 7.77Z"
                    fill="black"
                    fill-opacity="0.5"
                  />
                  <path
                    d="M20.7896 14.7004C19.6696 15.4504 18.0996 15.7304 16.6496 15.5404C17.0296 14.7204 17.2296 13.8104 17.2396 12.8504C17.2396 11.8504 17.0196 10.9004 16.5996 10.0704C18.0796 9.8704 19.6496 10.1504 20.7796 10.9004C22.3596 11.9404 22.3596 13.6504 20.7896 14.7004Z"
                    fill="black"
                    fill-opacity="0.5"
                  />
                  <path
                    d="M6.44016 7.77C6.51016 7.76 6.58016 7.76 6.65016 7.77C8.20016 7.72 9.43016 6.45 9.43016 4.89C9.43016 3.29 8.14016 2 6.54016 2C4.95016 2 3.66016 3.29 3.66016 4.89C3.66016 6.45 4.89016 7.72 6.44016 7.77Z"
                    fill="black"
                    fill-opacity="0.5"
                  />
                  <path
                    d="M6.55012 12.8496C6.55012 13.8196 6.76012 14.7396 7.14012 15.5696C5.73012 15.7196 4.26012 15.4196 3.18012 14.7096C1.60012 13.6596 1.60012 11.9496 3.18012 10.8996C4.25012 10.1796 5.76012 9.88962 7.18012 10.0496C6.77012 10.8896 6.55012 11.8396 6.55012 12.8496Z"
                    fill="black"
                    fill-opacity="0.5"
                  />
                  <path
                    d="M12.1198 15.87C12.0398 15.86 11.9498 15.86 11.8598 15.87C10.0198 15.81 8.5498 14.3 8.5498 12.44C8.5598 10.54 10.0898 9 11.9998 9C13.8998 9 15.4398 10.54 15.4398 12.44C15.4298 14.3 13.9698 15.81 12.1198 15.87Z"
                    fill="black"
                    fill-opacity="0.5"
                  />
                  <path
                    d="M8.8698 17.9396C7.3598 18.9496 7.3598 20.6096 8.8698 21.6096C10.5898 22.7596 13.4098 22.7596 15.1298 21.6096C16.6398 20.5996 16.6398 18.9396 15.1298 17.9396C13.4198 16.7896 10.5998 16.7896 8.8698 17.9396Z"
                    fill="black"
                    fill-opacity="0.5"
                  />
                </svg>
              </i>
            </div>
            <div class="nav-item-text" v-if="!menuCollapsed">
              {{ $t('MENU_STUDENT') }}
            </div>
          </md-list-item>

          <md-list-item
            :class="isActive('ListClassHomework')"
            @click.prevent="open('ListClassHomework')"
          >
            <md-tooltip md-direction="right">{{
              $t('MENU_EXERCISE')
            }}</md-tooltip>
            <div class="active-bar" />
            <div class="nav-item">
              <i class="md-svg-loader md-icon md-icon-image md-theme-default">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M22 4.84969V16.7397C22 17.7097 21.21 18.5997 20.24 18.7197L19.93 18.7597C18.29 18.9797 15.98 19.6597 14.12 20.4397C13.47 20.7097 12.75 20.2197 12.75 19.5097V5.59969C12.75 5.22969 12.96 4.88969 13.29 4.70969C15.12 3.71969 17.89 2.83969 19.77 2.67969H19.83C21.03 2.67969 22 3.64969 22 4.84969Z"
                    fill="black"
                    fill-opacity="0.5"
                  />
                  <path
                    d="M10.71 4.70969C8.87999 3.71969 6.10999 2.83969 4.22999 2.67969H4.15999C2.95999 2.67969 1.98999 3.64969 1.98999 4.84969V16.7397C1.98999 17.7097 2.77999 18.5997 3.74999 18.7197L4.05999 18.7597C5.69999 18.9797 8.00999 19.6597 9.86999 20.4397C10.52 20.7097 11.24 20.2197 11.24 19.5097V5.59969C11.24 5.21969 11.04 4.88969 10.71 4.70969ZM4.99999 7.73969H7.24999C7.65999 7.73969 7.99999 8.07969 7.99999 8.48969C7.99999 8.90969 7.65999 9.23969 7.24999 9.23969H4.99999C4.58999 9.23969 4.24999 8.90969 4.24999 8.48969C4.24999 8.07969 4.58999 7.73969 4.99999 7.73969ZM7.99999 12.2397H4.99999C4.58999 12.2397 4.24999 11.9097 4.24999 11.4897C4.24999 11.0797 4.58999 10.7397 4.99999 10.7397H7.99999C8.40999 10.7397 8.74999 11.0797 8.74999 11.4897C8.74999 11.9097 8.40999 12.2397 7.99999 12.2397Z"
                    fill="black"
                    fill-opacity="0.5"
                  />
                </svg>
              </i>
            </div>
            <div class="nav-item-text" v-if="!menuCollapsed">
              {{ $t('MENU_EXERCISE') }}
            </div>
          </md-list-item>

          <!-- TEMP: leaderboard menu hidden for deploy; remove `false &&` to re-enable -->
          <md-list-item
            v-if="$myDevice !== 'isMobileApp'"
            :class="isActive('V2HomeworkLeaderboard')"
            @click.prevent="open('V2HomeworkLeaderboard')"
          >
            <md-tooltip md-direction="right">{{
              $t('MENU_HOMEWORK_LEADERBOARD')
            }}</md-tooltip>
            <div class="active-bar" />
            <div class="nav-item">
              <i class="md-svg-loader md-icon md-icon-image md-theme-default">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M7 3h10v2h3v3a4 4 0 0 1-4 4h-.35A5 5 0 0 1 13 14.9V17h3v4H8v-4h3v-2.1A5 5 0 0 1 8.35 12H8a4 4 0 0 1-4-4V5h3V3zm-1 4v1a2 2 0 0 0 1 1.73V7H6zm11 0v2.73A2 2 0 0 0 18 8V7h-1z"
                    fill="black"
                    fill-opacity="0.5"
                  />
                </svg>
              </i>
            </div>
            <div class="nav-item-text" v-if="!menuCollapsed">
              {{ $t('MENU_HOMEWORK_LEADERBOARD') }}
            </div>
          </md-list-item>

          <!-- <md-list-item
            :class="isActive('ListClassStudy')"
            @click.prevent="open('ListClassStudy')"
          >
            <md-tooltip md-direction="right">{{
              $t('MENU_LESSON')
            }}</md-tooltip>
            <div class="active-bar" />
            <div class="nav-item">
              <i class="md-svg-loader md-icon md-icon-image md-theme-default">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2ZM18.5 16.4C18.5 17.9 17.9 18.5 16.4 18.5H12.6C11.1 18.5 10.5 17.9 10.5 16.4V14.6C10.5 13.1 11.1 12.5 12.6 12.5H16.4C17.9 12.5 18.5 13.1 18.5 14.6V16.4Z"
                    fill="black"
                    fill-opacity="0.5"
                  />
                </svg>
              </i>
            </div>
            <div class="nav-item-text" v-if="!menuCollapsed">
              {{ $t('MENU_LESSON') }}
            </div>
          </md-list-item> -->

          <md-list-item
            v-if="$myDevice !== 'isMobileApp'"
            :class="isActive('V2VirtualTestCenter')"
            @click.prevent="open('V2VirtualTestCenter')"
          >
            <md-tooltip md-direction="right">Trung tâm khảo thí</md-tooltip>
            <div class="active-bar" />
            <div class="nav-item">
              <i class="md-svg-loader md-icon md-icon-image md-theme-default">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M4 6h16v2H4V6zm0 5h16v2H4v-2zm0 5h16v2H4v-2z"
                    fill="black"
                    fill-opacity="0.5"
                  />
                </svg>
              </i>
            </div>
            <div class="nav-item-text" v-if="!menuCollapsed">
              Trung tâm khảo thí
            </div>
          </md-list-item>

          <md-list-item
            :class="isActive('ListTeacher')"
            @click.prevent="open('ListTeacher')"
            v-if="
              profile &&
              ((profile.schoolId &&
                (profile.roles.includes('super_admin') ||
                  profile.roles.includes('admin'))) ||
                profile.roles.includes('group_chief') ||
                profile.roles.includes('department_chief'))
            "
          >
            <md-tooltip md-direction="right">{{
              $t('MENU_TEACHER')
            }}</md-tooltip>
            <div class="active-bar" />
            <div class="nav-item">
              <i class="md-svg-loader md-icon md-icon-image md-theme-default">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M20.25 3.75H3.75C3.35218 3.75 2.97064 3.90804 2.68934 4.18934C2.40804 4.47064 2.25 4.85218 2.25 5.25V18.75C2.25 19.1478 2.40804 19.5294 2.68934 19.8107C2.97064 20.092 3.35218 20.25 3.75 20.25H5.00531C5.14726 20.25 5.2863 20.2098 5.40628 20.134C5.52627 20.0581 5.62227 19.9498 5.68313 19.8216C6.04783 19.0516 6.62363 18.4009 7.34357 17.9453C8.06351 17.4897 8.898 17.2478 9.75 17.2478C10.602 17.2478 11.4365 17.4897 12.1564 17.9453C12.8764 18.4009 13.4522 19.0516 13.8169 19.8216C13.8777 19.9498 13.9737 20.0581 14.0937 20.134C14.2137 20.2098 14.3527 20.25 14.4947 20.25H20.25C20.6478 20.25 21.0294 20.092 21.3107 19.8107C21.592 19.5294 21.75 19.1478 21.75 18.75V5.25C21.75 4.85218 21.592 4.47064 21.3107 4.18934C21.0294 3.90804 20.6478 3.75 20.25 3.75ZM9.75 15.75C9.15666 15.75 8.57664 15.5741 8.08329 15.2444C7.58994 14.9148 7.20542 14.4462 6.97836 13.8981C6.7513 13.3499 6.69189 12.7467 6.80764 12.1647C6.9234 11.5828 7.20912 11.0482 7.62868 10.6287C8.04824 10.2091 8.58279 9.9234 9.16473 9.80764C9.74667 9.69189 10.3499 9.7513 10.8981 9.97836C11.4462 10.2054 11.9148 10.5899 12.2444 11.0833C12.5741 11.5766 12.75 12.1567 12.75 12.75C12.75 13.5456 12.4339 14.3087 11.8713 14.8713C11.3087 15.4339 10.5456 15.75 9.75 15.75ZM20.25 18.75H14.9466C14.6195 18.1863 14.2028 17.6797 13.7128 17.25H18C18.1989 17.25 18.3897 17.171 18.5303 17.0303C18.671 16.8897 18.75 16.6989 18.75 16.5V7.5C18.75 7.30109 18.671 7.11032 18.5303 6.96967C18.3897 6.82902 18.1989 6.75 18 6.75H6C5.80109 6.75 5.61032 6.82902 5.46967 6.96967C5.32902 7.11032 5.25 7.30109 5.25 7.5V16.5C5.24992 16.6663 5.30513 16.828 5.40696 16.9595C5.50878 17.091 5.65145 17.185 5.8125 17.2266C5.31111 17.6609 4.8856 18.1758 4.55344 18.75H3.75V5.25H20.25V18.75Z"
                    fill="black"
                    fill-opacity="0.5"
                  />
                </svg>
              </i>
            </div>
            <div class="nav-item-text" v-if="!menuCollapsed">
              {{ $t('MENU_TEACHER') }}
            </div>
          </md-list-item>

          <!-- Sự kiện, Thi đua and Khảo thí are tabs of one entry (see EventTabs). -->
          <md-list-item
            v-if="eventTabs.length"
            :class="isActiveAny(eventModules)"
            @click.prevent="openEvents()"
          >
            <md-tooltip md-direction="right">{{ $t('MENU_EVENT') }}</md-tooltip>
            <div class="active-bar" />
            <div class="nav-item">
              <i class="md-svg-loader md-icon md-icon-image md-theme-default">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.3052 15.7059C3.11677 15.2614 3.01247 14.7729 3.01247 14.2605C3.01247 12.2106 4.67897 10.5441 6.72736 10.5441H17.2726C19.321 10.5441 20.9874 12.2106 20.9874 14.259V14.2605C20.9874 14.773 20.8831 15.2615 20.6947 15.706C21.8442 14.8756 22.5938 13.5243 22.5938 12.0011V11.9996C22.5938 9.48087 20.5446 7.43164 18.0257 7.43164H5.97427C3.45544 7.43164 1.40625 9.48087 1.40625 11.9996C1.40625 13.5237 2.15578 14.8753 3.3052 15.7059Z"
                  />
                  <path
                    d="M6.72734 11.9502C5.45436 11.9502 4.4187 12.9865 4.4187 14.2603C4.4187 15.5333 5.45436 16.5689 6.72734 16.5689H17.2726C18.5456 16.5689 19.5812 15.5333 19.5812 14.2588C19.5812 12.9858 18.5455 11.9502 17.2726 11.9502H6.72734Z"
                  />
                  <path
                    d="M4.4187 4.41877H7.48118C7.72488 4.41877 7.95119 4.29258 8.0793 4.0853C8.20741 3.87802 8.21904 3.61917 8.1101 3.4012L7.51418 2.20941L8.1101 1.01761C8.21908 0.799641 8.20741 0.540797 8.0793 0.333516C7.95119 0.126188 7.72488 0 7.48118 0H3.71558C3.32726 0 3.01245 0.314812 3.01245 0.703125V6.81234C3.44965 6.5617 3.9215 6.36506 4.4187 6.23086V4.41877Z"
                  />
                  <path
                    d="M11.197 4.41877H14.2595C14.5032 4.41877 14.7295 4.29258 14.8576 4.0853C14.9858 3.87802 14.9974 3.61917 14.8884 3.4012L14.2925 2.20941L14.8884 1.01761C14.9974 0.799641 14.9858 0.540797 14.8576 0.333516C14.7295 0.126188 14.5032 0 14.2595 0H10.4939C10.1056 0 9.79077 0.314812 9.79077 0.703125V6.02498H11.197V4.41877Z"
                  />
                  <path
                    d="M17.9751 4.41877H21.0376C21.2813 4.41877 21.5076 4.29258 21.6357 4.0853C21.7638 3.87802 21.7755 3.61917 21.6665 3.4012L21.0706 2.20941L21.6665 1.01761C21.7755 0.799641 21.7638 0.540797 21.6357 0.333516C21.5076 0.126188 21.2813 0 21.0376 0H17.272C16.8837 0 16.5688 0.314812 16.5688 0.703125V6.02498H17.9751V4.41877Z"
                  />
                  <path d="M10.4436 20.9873H13.5561V23.9998H10.4436V20.9873Z" />
                  <path
                    d="M18.0257 17.9752H5.97427C2.68003 17.9752 0 15.2952 0 12.001V17.2721C0 20.9934 3.01181 24.0002 6.72811 24.0002H9.0375V20.2846C9.0375 19.8963 9.35231 19.5815 9.74063 19.5815H14.2594C14.6477 19.5815 14.9625 19.8963 14.9625 20.2846V24.0002H17.2719C20.9932 24.0002 24 20.9884 24 17.2721V12.001C24 15.2952 21.32 17.9752 18.0257 17.9752Z"
                  />
                </svg>
              </i>
            </div>
            <div class="nav-item-text" v-if="!menuCollapsed">
              {{ $t('MENU_EVENT') }}
            </div>
          </md-list-item>

          <!-- Thi đua and Khảo thí moved into the Sự kiện tabs. -->
          <!-- <md-list-item
            :class="isActive('RTContest')"
            @click.prevent="open('RTContest')"
          >
            <md-tooltip md-direction="right">{{
              $t('MENU_RT_CONTEST')
            }}</md-tooltip>
            <div class="active-bar" />
            <div class="nav-item">
              <i class="md-svg-loader md-icon md-icon-image md-theme-default">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M14.35 2H9.65001C8.61001 2 7.76001 2.84 7.76001 3.88V4.82C7.76001 5.86 8.60001 6.7 9.64001 6.7H14.35C15.39 6.7 16.23 5.86 16.23 4.82V3.88C16.24 2.84 15.39 2 14.35 2Z"
                    fill="black"
                    fill-opacity="0.5"
                  />
                  <path
                    d="M17.24 4.82047C17.24 6.41047 15.94 7.71047 14.35 7.71047H9.64998C8.05998 7.71047 6.75998 6.41047 6.75998 4.82047C6.75998 4.26047 6.15998 3.91047 5.65998 4.17047C4.24998 4.92047 3.28998 6.41047 3.28998 8.12047V17.5305C3.28998 19.9905 5.29998 22.0005 7.75998 22.0005H16.24C18.7 22.0005 20.71 19.9905 20.71 17.5305V8.12047C20.71 6.41047 19.75 4.92047 18.34 4.17047C17.84 3.91047 17.24 4.26047 17.24 4.82047ZM15.34 12.7305L11.34 16.7305C11.19 16.8805 11 16.9505 10.81 16.9505C10.62 16.9505 10.43 16.8805 10.28 16.7305L8.77998 15.2305C8.48998 14.9405 8.48998 14.4605 8.77998 14.1705C9.06998 13.8805 9.54998 13.8805 9.83998 14.1705L10.81 15.1405L14.28 11.6705C14.57 11.3805 15.05 11.3805 15.34 11.6705C15.63 11.9605 15.63 12.4405 15.34 12.7305Z"
                    fill="black"
                    fill-opacity="0.5"
                  />
                </svg>
              </i>
            </div>
            <div class="nav-item-text" v-if="!menuCollapsed">
              {{ $t('MENU_RT_CONTEST') }}
            </div>
          </md-list-item> -->

          <!-- <md-list-item
            :class="isActive('TRcvContest')"
            @click.prevent="open('TRcvContest')"
          >
            <md-tooltip md-direction="right">{{
              $t('T_RCV_CONTEST_MENU')
            }}</md-tooltip>
            <div class="active-bar" />
            <div class="nav-item">
              <i class="md-svg-loader md-icon md-icon-image md-theme-default">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M11.25 18.25H9C7.9 18.25 7 19.15 7 20.25V20.5H6C5.59 20.5 5.25 20.84 5.25 21.25C5.25 21.66 5.59 22 6 22H18C18.41 22 18.75 21.66 18.75 21.25C18.75 20.84 18.41 20.5 18 20.5H17V20.25C17 19.15 16.1 18.25 15 18.25H12.75V15.96C12.5 15.99 12.25 16 12 16C11.75 16 11.5 15.99 11.25 15.96V18.25Z"
                    fill="black"
                    fill-opacity="0.5"
                  />
                  <path
                    d="M18.4803 11.64C19.1403 11.39 19.7203 10.98 20.1803 10.52C21.1103 9.49 21.7203 8.26 21.7203 6.82C21.7203 5.38 20.5903 4.25 19.1503 4.25H18.5903C17.9403 2.92 16.5803 2 15.0003 2H9.00027C7.42027 2 6.06027 2.92 5.41027 4.25H4.85027C3.41027 4.25 2.28027 5.38 2.28027 6.82C2.28027 8.26 2.89027 9.49 3.82027 10.52C4.28027 10.98 4.86027 11.39 5.52027 11.64C6.56027 14.2 9.06027 16 12.0003 16C14.9403 16 17.4403 14.2 18.4803 11.64ZM14.8403 8.45L14.2203 9.21C14.1203 9.32 14.0503 9.54 14.0603 9.69L14.1203 10.67C14.1603 11.27 13.7303 11.58 13.1703 11.36L12.2603 11C12.1203 10.95 11.8803 10.95 11.7403 11L10.8303 11.36C10.2703 11.58 9.84027 11.27 9.88027 10.67L9.94027 9.69C9.95027 9.54 9.88027 9.32 9.78027 9.21L9.16027 8.45C8.77027 7.99 8.94027 7.48 9.52027 7.33L10.4703 7.09C10.6203 7.05 10.8003 6.91 10.8803 6.78L11.4103 5.96C11.7403 5.45 12.2603 5.45 12.5903 5.96L13.1203 6.78C13.2003 6.91 13.3803 7.05 13.5303 7.09L14.4803 7.33C15.0603 7.48 15.2303 7.99 14.8403 8.45Z"
                    fill="black"
                    fill-opacity="0.5"
                  />
                </svg>
              </i>
            </div>
            <div class="nav-item-text" v-if="!menuCollapsed">
              {{ $t('T_RCV_CONTEST_MENU') }}
            </div>
          </md-list-item> -->

          <!-- <md-list-item
            v-if="profile && ((profile.schoolId && (profile.roles.includes('super_admin') || profile.roles.includes('admin')) || profile.roles.includes('group_chief') || profile.roles.includes('department_chief')))"
            :class="isActive('Reports')"
            @click.prevent="open('Reports')">
            <md-tooltip md-direction="right">{{ $t('MENU_REPORT') }}</md-tooltip>
            <div class="active-bar" />
            <div class="nav-item">
              <i class="md-svg-loader md-icon md-icon-image md-theme-default">
                <svg-icon icon-class="report-svgrepo-com"/>
              </i>
            </div>
            <div class="nav-item-text">{{ $t('MENU_REPORT') }}</div>
          </md-list-item> -->

          <!-- Center finance / sales (v2) — shown only when /teacher/center/me says enabled -->
          <template v-for="group in centerOtherGroups">
            <div :key="'cg-' + group.key" class="expand-menu">
              <div class="expand-menu-title" v-if="!menuCollapsed">
                {{ $t(group.titleKey) }}
              </div>
            </div>
            <md-list-item
              v-for="item in group.items"
              :key="'ci-' + item.name"
              :class="isActive(item.name)"
              @click.prevent="open(item.name)"
            >
              <md-tooltip md-direction="right">{{
                $t(item.labelKey)
              }}</md-tooltip>
              <div class="active-bar" />
              <div class="nav-item">
                <i
                  class="md-svg-loader md-icon md-icon-image md-theme-default"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path :d="item.icon" fill="black" fill-opacity="0.5" />
                  </svg>
                </i>
              </div>
              <div class="nav-item-text" v-if="!menuCollapsed">
                {{ $t(item.labelKey) }}
              </div>
            </md-list-item>
          </template>

          <div class="expand-menu">
            <div class="expand-menu-title" v-if="!menuCollapsed">Sàn</div>
          </div>

          <md-list-item
            v-if="$myDevice !== 'isMobileApp'"
            :class="isActive('V2CourseMarketplace')"
            @click.prevent="open('V2CourseMarketplace')"
          >
            <md-tooltip md-direction="right">Sàn khoá học</md-tooltip>
            <div class="active-bar" />
            <div class="nav-item">
              <i class="md-svg-loader md-icon md-icon-image md-theme-default">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20V5a1 1 0 0 0-1-1H6.5A2.5 2.5 0 0 0 4 6.5v13zM6.5 19H20v1.5H6.5a.75.75 0 0 1 0-1.5z"
                    fill="black"
                    fill-opacity="0.5"
                  />
                </svg>
              </i>
            </div>
            <div class="nav-item-text" v-if="!menuCollapsed">Sàn khoá học</div>
          </md-list-item>

          <md-list-item
            v-if="
              $myDevice !== 'isMobileApp' &&
              profile &&
              profile.roles &&
              profile.roles.includes('group_chief')
            "
            :class="isActive('V2CmSales')"
            @click.prevent="open('V2CmSales')"
          >
            <md-tooltip md-direction="right">Doanh thu</md-tooltip>
            <div class="active-bar" />
            <div class="nav-item">
              <i class="md-svg-loader md-icon md-icon-image md-theme-default">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M21 7.5H3a1 1 0 0 0-1 1v9a2 2 0 0 0 2 2h15a2 2 0 0 0 2-2v-9a1 1 0 0 0-1-1zm-4 7a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM19 6H5l11-2.4a1 1 0 0 1 1.2.76L17.5 6H19z"
                    fill="black"
                    fill-opacity="0.5"
                  />
                </svg>
              </i>
            </div>
            <div class="nav-item-text" v-if="!menuCollapsed">Doanh thu</div>
          </md-list-item>

          <md-list-item
            v-if="
              $myDevice !== 'isMobileApp' &&
              profile &&
              profile.roles &&
              profile.roles.includes('group_chief')
            "
            :class="isActive('V2CmB2b')"
            @click.prevent="open('V2CmB2b')"
          >
            <md-tooltip md-direction="right">B2B</md-tooltip>
            <div class="active-bar" />
            <div class="nav-item">
              <i class="md-svg-loader md-icon md-icon-image md-theme-default">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M4 4h16l-1.5 5.5A2 2 0 0 1 16.6 11H7.4a2 2 0 0 1-1.9-1.5L4 4zm2 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm10 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
                    fill="black"
                    fill-opacity="0.5"
                  />
                </svg>
              </i>
            </div>
            <div class="nav-item-text" v-if="!menuCollapsed">B2B</div>
          </md-list-item>

          <!-- <md-list-item
            v-if="!$isMobileDevice && !collapseDocument"
            :class="isActive('Document')"
            @click.prevent="open('Document')"
          >
            <md-tooltip md-direction="right">{{
              $t('MENU_MARKETPLACE')
            }}</md-tooltip>
            <div class="active-bar" />
            <div class="nav-item">
              <i class="md-svg-loader md-icon md-icon-image md-theme-default">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M15.7997 2.21048C15.3897 1.80048 14.6797 2.08048 14.6797 2.65048V6.14048C14.6797 7.60048 15.9197 8.81048 17.4297 8.81048C18.3797 8.82048 19.6997 8.82048 20.8297 8.82048C21.3997 8.82048 21.6997 8.15048 21.2997 7.75048C19.8597 6.30048 17.2797 3.69048 15.7997 2.21048Z"
                    fill="black"
                    fill-opacity="0.5"
                  />
                  <path
                    d="M14.7596 19.2598C12.4096 19.4298 12.4096 22.8298 14.7596 22.9998H20.3196C20.9896 22.9998 21.6496 22.7498 22.1396 22.2998C23.7896 20.8598 22.9096 17.9798 20.7396 17.7098C19.9596 13.0198 13.1796 14.7998 14.7796 19.2698"
                    fill="black"
                    fill-opacity="0.5"
                  />
                  <path
                    d="M21.5 11.19V14.44C21.5 14.74 21.06 14.88 20.84 14.67C20.36 14.2 19.77 13.84 19.09 13.63C17.41 13.11 15.46 13.62 14.25 14.9C13.44 15.74 13.03 16.81 13.04 17.97C13.04 18.16 12.95 18.33 12.8 18.44C12 19.05 11.5 20.01 11.5 21.12C11.5 21.2 11.5 21.28 11.51 21.36C11.53 21.68 11.3 21.99 10.97 21.99H8.07C4.99 21.99 2.5 19.99 2.5 16.42V7.57C2.5 4 4.99 2 8.07 2H12.31C12.86 2 13.31 2.45 13.31 3V5.89C13.31 8.27 15.23 10.19 17.61 10.19H20.5C21.05 10.19 21.5 10.64 21.5 11.19Z"
                    fill="black"
                    fill-opacity="0.5"
                  />
                </svg>
              </i>
            </div>
            <div class="nav-item-text">{{ $t('MENU_MARKETPLACE') }}</div>
          </md-list-item> -->

          <!-- Chuyên môn (Plan) served public schools, a segment no longer targeted. -->
          <!-- <md-list-item
            :class="isActive('Plan')"
            to="/plan"
          >
            <md-tooltip md-direction="right">{{ $t('MENU_PLAN') }}</md-tooltip>
            <div class="active-bar" />
            <div class="nav-item">
              <i class="md-svg-loader md-icon md-icon-image md-theme-default">
                <svg
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 31 32"
                  enable-background="new 0 0 31 32"
                  xml:space="preserve"
                  fill="#000000"
                >
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g
                    id="SVGRepo_tracerCarrier"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></g>
                  <g id="SVGRepo_iconCarrier">
                    <g>
                      <path
                        fill="#808184"
                        d="M23,4.5c-0.276,0-0.5,0.224-0.5,0.5v3.229l-2.295,2.26c-2.146-2.006-5.017-3.244-8.179-3.244 c-6.617,0-12,5.383-12,12c0,3.531,1.542,6.7,3.977,8.898l-2.355,3.024c-0.17,0.218-0.131,0.532,0.087,0.702 c0.092,0.071,0.2,0.105,0.308,0.105c0.148,0,0.296-0.066,0.395-0.193l2.335-2.999c2.017,1.538,4.527,2.463,7.254,2.463 c2.724,0,5.231-0.923,7.247-2.458l2.271,3.013C21.642,31.931,21.791,32,21.942,32c0.105,0,0.211-0.033,0.301-0.101 c0.221-0.167,0.265-0.48,0.099-0.7l-2.299-3.051c2.438-2.198,3.982-5.37,3.982-8.903c0-3.096-1.188-5.912-3.12-8.043L23.143,9H26.5 C26.776,9,27,8.776,27,8.5S26.776,8,26.5,8h-2.342l1.016-1H28.5C28.776,7,29,6.776,29,6.5S28.776,6,28.5,6h-2.311l1.016-1H30.5 C30.776,5,31,4.776,31,4.5S30.776,4,30.5,4h-3V1c0-0.276-0.224-0.5-0.5-0.5S26.5,0.724,26.5,1v3.291l-1,0.985V3 c0-0.276-0.224-0.5-0.5-0.5S24.5,2.724,24.5,3v3.26l-1,0.985V5C23.5,4.724,23.276,4.5,23,4.5z M23.025,19.246 c0,6.065-4.935,11-11,11s-11-4.935-11-11s4.935-11,11-11c2.883,0,5.503,1.124,7.467,2.946l-2.137,2.105 c-1.417-1.27-3.281-2.051-5.329-2.051c-4.411,0-8,3.589-8,8s3.589,8,8,8s8-3.589,8-8c0-2.004-0.746-3.833-1.968-5.238l2.136-2.103 C21.948,13.854,23.025,16.423,23.025,19.246z M15.025,19.246c0,1.654-1.346,3-3,3s-3-1.346-3-3s1.346-3,3-3 c0.655,0,1.257,0.217,1.751,0.574l-2.101,2.069c-0.197,0.194-0.199,0.511-0.006,0.707c0.098,0.1,0.228,0.149,0.356,0.149 c0.127,0,0.254-0.048,0.351-0.144l2.104-2.072C14.821,18.017,15.025,18.607,15.025,19.246z M14.489,16.118 c-0.681-0.538-1.53-0.873-2.463-0.873c-2.206,0-4,1.794-4,4s1.794,4,4,4s4-1.794,4-4c0-0.911-0.318-1.743-0.834-2.416l2.154-2.121 c1.045,1.223,1.68,2.806,1.68,4.537c0,3.86-3.141,7-7,7s-7-3.14-7-7s3.141-7,7-7c1.769,0,3.383,0.665,4.617,1.752L14.489,16.118z"
                      ></path>
                    </g>
                  </g>
                </svg>
              </i>
            </div>
            <div class="nav-item-text" v-if="!menuCollapsed">
              {{ $t('MENU_PLAN') }}
            </div>
          </md-list-item> -->

          <div class="expand-menu">
            <div class="expand-menu-title" v-if="!menuCollapsed">
              {{ $t('OTHER') }}
            </div>
          </div>

          <md-list-item
            v-if="
              profile &&
              ((profile.schoolId &&
                (profile.roles.includes('super_admin') ||
                  profile.roles.includes('admin') ||
                  profile?.school?.houseId)) ||
                profile.roles.includes('group_chief') ||
                profile.roles.includes('department_chief'))
            "
            :class="isActive('MentorHouse')"
            to="/nha"
          >
            <md-tooltip md-direction="right">{{
              $t('MENU_MENTOR_HOUSE')
            }}</md-tooltip>
            <div class="active-bar" />
            <div class="nav-item">
              <i class="md-svg-loader md-icon md-icon-image md-theme-default">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="#000000"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 15.5C9.59 15.5 9.25 15.84 9.25 16.25V17.75C9.25 18.16 9.59 18.5 10 18.5C10.41 18.5 10.75 18.16 10.75 17.75V16.25C10.75 15.84 10.41 15.5 10 15.5Z"
                  />
                  <path
                    d="M22 21.2497H21V9.97973C21 9.35973 20.72 8.77973 20.23 8.39973L13.23 2.95973C12.51 2.38973 11.49 2.38973 10.77 2.95973L3.77 8.39973C3.28 8.77973 3 9.35973 3 9.96973L2.95 21.2497H2C1.59 21.2497 1.25 21.5797 1.25 21.9997C1.25 22.4097 1.59 22.7497 2 22.7497H22C22.41 22.7497 22.75 22.4097 22.75 21.9997C22.75 21.5797 22.41 21.2497 22 21.2497ZM10.5 6.74973H13.5C13.91 6.74973 14.25 7.08973 14.25 7.49973C14.25 7.90973 13.91 8.24973 13.5 8.24973H10.5C10.09 8.24973 9.75 7.90973 9.75 7.49973C9.75 7.08973 10.09 6.74973 10.5 6.74973ZM17 21.2497H7V12.4997C7 11.6697 7.67 10.9997 8.5 10.9997H15.5C16.33 10.9997 17 11.6697 17 12.4997V21.2497Z"
                  />
                </svg>
              </i>
            </div>
            <div class="nav-item-text" v-if="!menuCollapsed">
              {{ $t('MENU_MENTOR_HOUSE') }}
            </div>
          </md-list-item>

          <md-list-item
            :class="isActive('ExamVault')"
            @click.prevent="open('ExamVault')"
          >
            <md-tooltip md-direction="right">{{
              $t('MENU_EXAM_VAULT')
            }}</md-tooltip>
            <div class="active-bar" />
            <div class="nav-item">
              <i class="md-svg-loader md-icon md-icon-image md-theme-default">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M15.7997 2.21048C15.3897 1.80048 14.6797 2.08048 14.6797 2.65048V6.14048C14.6797 7.60048 15.9197 8.81048 17.4297 8.81048C18.3797 8.82048 19.6997 8.82048 20.8297 8.82048C21.3997 8.82048 21.6997 8.15048 21.2997 7.75048C19.8597 6.30048 17.2797 3.69048 15.7997 2.21048Z"
                    fill="black"
                    fill-opacity="0.5"
                  />
                  <path
                    d="M14.7596 19.2598C12.4096 19.4298 12.4096 22.8298 14.7596 22.9998H20.3196C20.9896 22.9998 21.6496 22.7498 22.1396 22.2998C23.7896 20.8598 22.9096 17.9798 20.7396 17.7098C19.9596 13.0198 13.1796 14.7998 14.7796 19.2698"
                    fill="black"
                    fill-opacity="0.5"
                  />
                  <path
                    d="M21.5 11.19V14.44C21.5 14.74 21.06 14.88 20.84 14.67C20.36 14.2 19.77 13.84 19.09 13.63C17.41 13.11 15.46 13.62 14.25 14.9C13.44 15.74 13.03 16.81 13.04 17.97C13.04 18.16 12.95 18.33 12.8 18.44C12 19.05 11.5 20.01 11.5 21.12C11.5 21.2 11.5 21.28 11.51 21.36C11.53 21.68 11.3 21.99 10.97 21.99H8.07C4.99 21.99 2.5 19.99 2.5 16.42V7.57C2.5 4 4.99 2 8.07 2H12.31C12.86 2 13.31 2.45 13.31 3V5.89C13.31 8.27 15.23 10.19 17.61 10.19H20.5C21.05 10.19 21.5 10.64 21.5 11.19Z"
                    fill="black"
                    fill-opacity="0.5"
                  />
                </svg>
              </i>
            </div>
            <div class="nav-item-text" v-if="!menuCollapsed">
              {{ $t('MENU_EXAM_VAULT') }}
            </div>
          </md-list-item>
          <md-list-item
            :class="isActive('V2ResourceAssignment')"
            @click.prevent="open('V2ResourceAssignment')"
          >
            <md-tooltip md-direction="right">{{
              $t('MENU_RESOURCE_ASSIGNMENT')
            }}</md-tooltip>
            <div class="active-bar" />
            <div class="nav-item">
              <i class="md-svg-loader md-icon md-icon-image md-theme-default">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M9 11H3v10h6V11zm6-7H9v17h6V4zm6 4h-6v13h6V8z"
                    fill="black"
                    fill-opacity="0.5"
                  />
                </svg>
              </i>
            </div>
            <div class="nav-item-text" v-if="!menuCollapsed">
              {{ $t('MENU_RESOURCE_ASSIGNMENT') }}
            </div>
          </md-list-item>

          <md-list-item
            :class="isActive('Instruction')"
            @click.prevent="open('Instruction')"
            to="/huong-dan"
          >
            <md-tooltip md-direction="right">{{
              $t('MENU_INSTRUCTION')
            }}</md-tooltip>
            <div class="active-bar"></div>
            <div class="nav-item">
              <i class="md-svg-loader md-icon md-icon-image md-theme-default">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2ZM11.5 17.25C11.5 17.61 11.14 17.85 10.81 17.71C9.6 17.19 8.02 16.71 6.92 16.57L6.73 16.55C6.12 16.47 5.62 15.9 5.62 15.28V7.58C5.62 6.81 6.24 6.24 7 6.3C8.25 6.4 10.1 7 11.26 7.66C11.42 7.75 11.5 7.92 11.5 8.09V17.25ZM18.38 15.27C18.38 15.89 17.88 16.46 17.27 16.54L17.06 16.56C15.97 16.71 14.4 17.18 13.19 17.69C12.86 17.83 12.5 17.59 12.5 17.23V8.08C12.5 7.9 12.59 7.73 12.75 7.64C13.91 6.99 15.72 6.41 16.95 6.3H16.99C17.76 6.3 18.38 6.92 18.38 7.69V15.27Z"
                    fill="black"
                    fill-opacity="0.5"
                  />
                </svg>
              </i>
            </div>
            <div class="nav-item-text" v-if="!menuCollapsed">
              {{ $t('MENU_INSTRUCTION') }}
            </div>
          </md-list-item>

          <!-- Bộ sách is dropped from the menu (PO, 2026-11). -->
          <!-- <md-list-item
            :class="isActive('SchoolBookCategory')"
            @click.prevent="open('SchoolBookCategory')"
            v-if="
              profile.roles.includes('super_admin') ||
              profile.roles.includes('admin')
            "
          >
            <md-tooltip md-direction="right">{{
              $t('SCHOOL_BOOK_CATEGORY')
            }}</md-tooltip>
            <div class="active-bar" />
            <div class="nav-item">
              <i class="md-svg-loader md-icon md-icon-image md-theme-default">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M22 4.84969V16.7397C22 17.7097 21.21 18.5997 20.24 18.7197L19.93 18.7597C18.29 18.9797 15.98 19.6597 14.12 20.4397C13.47 20.7097 12.75 20.2197 12.75 19.5097V5.59969C12.75 5.22969 12.96 4.88969 13.29 4.70969C15.12 3.71969 17.89 2.83969 19.77 2.67969H19.83C21.03 2.67969 22 3.64969 22 4.84969Z"
                    fill="black"
                    fill-opacity="0.5"
                  />
                  <path
                    d="M10.71 4.70969C8.87999 3.71969 6.10999 2.83969 4.22999 2.67969H4.15999C2.95999 2.67969 1.98999 3.64969 1.98999 4.84969V16.7397C1.98999 17.7097 2.77999 18.5997 3.74999 18.7197L4.05999 18.7597C5.69999 18.9797 8.00999 19.6597 9.86999 20.4397C10.52 20.7097 11.24 20.2197 11.24 19.5097V5.59969C11.24 5.21969 11.04 4.88969 10.71 4.70969ZM4.99999 7.73969H7.24999C7.65999 7.73969 7.99999 8.07969 7.99999 8.48969C7.99999 8.90969 7.65999 9.23969 7.24999 9.23969H4.99999C4.58999 9.23969 4.24999 8.90969 4.24999 8.48969C4.24999 8.07969 4.58999 7.73969 4.99999 7.73969ZM7.99999 12.2397H4.99999C4.58999 12.2397 4.24999 11.9097 4.24999 11.4897C4.24999 11.0797 4.58999 10.7397 4.99999 10.7397H7.99999C8.40999 10.7397 8.74999 11.0797 8.74999 11.4897C8.74999 11.9097 8.40999 12.2397 7.99999 12.2397Z"
                    fill="black"
                    fill-opacity="0.5"
                  />
                </svg>
              </i>
            </div>
            <div class="nav-item-text" v-if="!menuCollapsed">
              {{ $t('SCHOOL_BOOK_CATEGORY') }}
            </div>
          </md-list-item> -->

          <!-- Cài đặt also holds Cấu hình trung tâm (a tab on the School page). -->
          <md-list-item
            v-if="isSchoolAdmin || canCenterSettings"
            :class="isActiveAny(['School', 'V2CenterSettings'])"
            @click.prevent="openSettings()"
          >
            <md-tooltip md-direction="right">{{
              $t('MENU_SETTING')
            }}</md-tooltip>
            <div class="active-bar" />
            <div class="nav-item">
              <i class="md-svg-loader md-icon md-icon-image md-theme-default">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M20.1 9.22043C18.29 9.22043 17.55 7.94042 18.45 6.37042C18.97 5.46042 18.66 4.30042 17.75 3.78042L16.02 2.79042C15.23 2.32042 14.21 2.60042 13.74 3.39042L13.63 3.58042C12.73 5.15042 11.25 5.15042 10.34 3.58042L10.23 3.39042C9.78 2.60042 8.76 2.32042 7.97 2.79042L6.24 3.78042C5.33 4.30042 5.02 5.47042 5.54 6.38042C6.45 7.94042 5.71 9.22043 3.9 9.22043C2.86 9.22043 2 10.0704 2 11.1204V12.8804C2 13.9204 2.85 14.7804 3.9 14.7804C5.71 14.7804 6.45 16.0604 5.54 17.6304C5.02 18.5404 5.33 19.7004 6.24 20.2204L7.97 21.2104C8.76 21.6804 9.78 21.4004 10.25 20.6104L10.36 20.4204C11.26 18.8504 12.74 18.8504 13.65 20.4204L13.76 20.6104C14.23 21.4004 15.25 21.6804 16.04 21.2104L17.77 20.2204C18.68 19.7004 18.99 18.5304 18.47 17.6304C17.56 16.0604 18.3 14.7804 20.11 14.7804C21.15 14.7804 22.01 13.9304 22.01 12.8804V11.1204C22 10.0804 21.15 9.22043 20.1 9.22043ZM12 15.2504C10.21 15.2504 8.75 13.7904 8.75 12.0004C8.75 10.2104 10.21 8.75042 12 8.75042C13.79 8.75042 15.25 10.2104 15.25 12.0004C15.25 13.7904 13.79 15.2504 12 15.2504Z"
                    fill="black"
                    fill-opacity="0.5"
                  />
                </svg>
              </i>
            </div>
            <div class="nav-item-text" v-if="!menuCollapsed">
              {{ $t('MENU_SETTING') }}
            </div>
          </md-list-item>
          <!-- Scrolls with the menu; the user menu lives in the top bar. -->
          <li v-if="!menuCollapsed" class="drawer-version">Version 3.1.30</li>
        </md-list>
      </md-app-drawer>

      <md-app-content
        :class="{ 'md-app-content--v2': $route.path.startsWith('/v2') }"
        style="padding: 0"
      >
        <header class="host-topbar">
          <md-button
            class="md-icon-button md-small-show"
            @click="menuVisible = !menuVisible"
          >
            <md-icon>menu</md-icon>
          </md-button>
          <el-breadcrumb
            v-if="breadcrumb.length"
            separator="/"
            class="host-topbar__crumbs"
          >
            <el-breadcrumb-item v-for="(b, i) in breadcrumb" :key="i">
              <a
                v-if="b.path && i < breadcrumb.length - 1"
                :href="b.path"
                @click.prevent="$router.push(b.path)"
                >{{ b.label }}</a
              >
              <span v-else>{{ b.label }}</span>
            </el-breadcrumb-item>
          </el-breadcrumb>
          <div class="host-topbar__end">
            <LoggedUser :menuCollapsed="true" />
          </div>
        </header>
        <div class="host-content">
          <router-view />
        </div>
      </md-app-content>
    </md-app>
  </div>
</template>

<script>
import get from 'lodash/get'
import store from '@/store'
import { mapGetters } from 'vuex'
import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css'
import LoggedUser from '@/views/dashboard/LoggedUser'
import { fetchCenterMe, canOpenCenterSettings } from '@/utils/center-me'
import { eventTabs, EVENT_TAB_MODULES } from '@/utils/event-tabs'
import { Popover } from 'element-ui'
import { hostBreadcrumb } from '@/micro/host-breadcrumb'
import { routeBreadcrumb } from '@/utils/route-breadcrumb'

// Center/CRM menu definition. `roles` (group or item): center roles that see
// it (manager sees everything); omitted = every user once the module is
// enabled, plain teachers included. Mirrors the v2 router `meta.centerRoles`.
const CENTER_ICONS = {
  classes: 'M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z',
  students:
    'M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z',
  attendance:
    'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z',
  timetable:
    'M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z',
  fees: 'M18 17H6v-2h12v2zm0-4H6v-2h12v2zm0-4H6V7h12v2zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20z',
  timesheets:
    'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z',
  payroll:
    'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z',
  crm: 'M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z',
  contacts:
    'M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z',
  opportunities:
    'M6 5H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm14 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-7 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z',
  settings:
    'M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z'
}

const CENTER_MENU = [
  {
    key: 'training',
    titleKey: 'MENU_CENTER_TRAINING',
    items: [
      { name: 'V2CenterClasses', labelKey: 'MENU_CENTER_CLASSES', icon: CENTER_ICONS.classes },
      {
        name: 'V2CenterStudents',
        labelKey: 'MENU_CENTER_STUDENTS',
        icon: CENTER_ICONS.students,
        roles: ['academic', 'sale', 'accountant']
      },
      { name: 'V2CenterAttendance', labelKey: 'MENU_CENTER_ATTENDANCE', icon: CENTER_ICONS.attendance },
      { name: 'V2CenterTimetable', labelKey: 'MENU_CENTER_TIMETABLE', icon: CENTER_ICONS.timetable }
    ]
  },
  {
    key: 'finance',
    titleKey: 'MENU_CENTER_FINANCE',
    items: [
      {
        name: 'V2CenterFees',
        labelKey: 'MENU_CENTER_FEES',
        icon: CENTER_ICONS.fees,
        roles: ['academic', 'sale', 'accountant']
      },
      { name: 'V2CenterTimesheets', labelKey: 'MENU_CENTER_TIMESHEETS', icon: CENTER_ICONS.timesheets },
      {
        name: 'V2CenterPayroll',
        labelKey: 'MENU_CENTER_PAYROLL',
        icon: CENTER_ICONS.payroll,
        // Everyone else (teachers, sale, giáo vụ) only sees their own payslip.
        // Role data can't tell who teaches, so the entry stays for them.
        personal: { exceptRoles: ['accountant'], labelKey: 'MENU_CENTER_MY_PAYSLIP' }
      }
    ]
  },
  {
    key: 'sales',
    titleKey: 'MENU_CENTER_SALES',
    // Giáo vụ (academic) has no Sales/CRM access (user guide §1).
    roles: ['sale'],
    items: [
      { name: 'V2CrmOverview', labelKey: 'MENU_CENTER_CRM_OVERVIEW', icon: CENTER_ICONS.crm },
      { name: 'V2CrmContacts', labelKey: 'MENU_CENTER_CONTACTS', icon: CENTER_ICONS.contacts },
      { name: 'V2CrmOpportunities', labelKey: 'MENU_CENTER_OPPORTUNITIES', icon: CENTER_ICONS.opportunities }
    ]
  }
]
// Cấu hình trung tâm is reached from Cài đặt (a tab on the School page).

Vue.use(Popover)

export default {
  components: {
    LoggedUser
  },
  computed: {
    ...mapGetters(['profile', 'group']),
    // A v2 page's own trail wins; otherwise the route table's.
    breadcrumb() {
      if (hostBreadcrumb.items.length) return hostBreadcrumb.items
      return routeBreadcrumb(this.$route, this.$router, (k) => this.$t(k))
    },
    centerMenuGroups() {
      const me = this.centerMe
      if (!me || this.$myDevice === 'isMobileApp') return []
      const roles = me.roles || []
      const isManager = roles.includes('manager')
      const sees = (x) =>
        !x.roles || isManager || x.roles.some((r) => roles.includes(r))
      if (!me.enabled) return []
      return CENTER_MENU.filter(sees)
        .map((g) => ({
          ...g,
          items: g.items.filter(sees).map((item) => {
            const p = item.personal
            if (!p || isManager || p.exceptRoles.some((r) => roles.includes(r))) {
              return item
            }
            return { ...item, labelKey: p.labelKey }
          })
        }))
        .filter((g) => g.items.length)
    },
    // Center training items sit inside Đào tạo; the rest keep their groups.
    centerTrainingItems() {
      const g = this.centerMenuGroups.find((x) => x.key === 'training')
      return g ? g.items : []
    },
    centerOtherGroups() {
      return this.centerMenuGroups.filter((g) => g.key !== 'training')
    },
    eventTabs() {
      return eventTabs(this.profile)
    },
    eventModules: () => EVENT_TAB_MODULES,
    isSchoolAdmin() {
      const p = this.profile
      return !!(
        p &&
        ((p.schoolId &&
          (p.roles.includes('super_admin') || p.roles.includes('admin'))) ||
          p.roles.includes('group_chief') ||
          p.roles.includes('department_chief'))
      )
    },
    canCenterSettings() {
      return this.$myDevice !== 'isMobileApp' && canOpenCenterSettings(this.centerMe)
    }
  },

  data: () => ({
    module: '',
    menuVisible: false,
    visible: false,
    menuCollapsed: false,
    centerMe: null
  }),

  created() {
    this.getCurrentModule(this.$route.path)
    this.init()
  },
  watch: {
    $route() {
      if (this.$route) {
        this.getCurrentModule(this.$route.path)
        // Host pages have no trail; v2 pages republish theirs.
        if (!this.$route.path.startsWith('/v2')) hostBreadcrumb.items = []
      }
    }
  },

  methods: {
    goToHome() {
      this.$router.push({ name: 'Home' })
    },
    init() {
      if (this.$myDevice === 'isMobileApp') return
      fetchCenterMe().then((me) => {
        this.centerMe = me
      })
    },
    async handleLogout() {
      try {
        await store.dispatch('user/logout', {})
        location.reload()
      } catch (error) {
        this.error = get(error, 'response.data.error.msg') || error.message
        setTimeout(() => {
          this.error = ''
        }, 3000)
      }
    },
    isSchoolAccount() {
      return (
        this.profile.roles &&
        (this.profile.roles.includes('super_admin') ||
          this.profile.roles.includes('admin') ||
          this.profile.roles.includes('group_chief') ||
          this.profile.roles.includes('department_chief'))
      )
    },
    editProfile() {
      this.visible = false
      this.$router.push({ name: 'Profile' })
    },
    getCurrentModule(routePath) {
      // Check known static v2 sub-paths before the 2-segment extraction,
      // otherwise /v2/course-marketplace/settings collapses to /v2/course-marketplace.
      if (routePath.startsWith('/v2/course-marketplace/settings')) {
        this.module = 'V2CmSettings'
        return
      }
      if (routePath.startsWith('/v2/course-marketplace/sales')) {
        this.module = 'V2CmSales'
        return
      }
      if (routePath.startsWith('/v2/course-marketplace/b2b')) {
        this.module = 'V2CmB2b'
        return
      }

      const centerModule = this.getCenterModule(routePath)
      if (centerModule) {
        this.module = centerModule
        return
      }

      let currentModule = 'Home'
      let root = '/' + (routePath.split('/')[1] || '')
      if (root === '/v2') {
        root = '/' + routePath.split('/').slice(1, 3).join('/')
      }

      switch (root) {
        case '/':
          currentModule = 'Home'
          break
        case '/trang-chu-cu':
          // Old dashboards are reached from the new home, not the sidebar.
          currentModule = 'Home'
          break
        case '/truong-hoc':
          currentModule = 'School'
          break
        case '/nha':
          currentModule = 'MentorHouse'
          break
        case '/rung-chuong-vang':
          currentModule = 'TRcvContest'
          break
        case '/plan':
          currentModule = 'Plan'
          break
        case '/plan-leader':
          currentModule = 'Plan'
          break
        case '/plan-teacher':
          currentModule = 'Plan'
          break
        case '/lesson-plan':
          currentModule = 'Plan'
          break
        case '/plan-leader-detail':
          currentModule = 'Plan'
          break
        case '/plan-teacher-detail':
          currentModule = 'Plan'
          break
        case '/lesson-plan-detail':
          currentModule = 'Plan'
          break
        case '/bai-tap':
          currentModule = 'ListClassHomework'
          break
        case '/bai-hoc':
          currentModule = 'ListClassStudy'
          break
        case '/giao-vien':
          currentModule = 'ListClassTeacher'
          break
        case '/lop-hoc':
          currentModule = 'Class'
          break
        case '/hoc-sinh':
          currentModule = 'Students'
          break
        case '/trung-tam-khao-thi':
          currentModule = 'RTContest'
          break
        case '/bao-cao':
          currentModule = 'Reports'
          break
        case '/kho-hoc-lieu':
          currentModule = 'ExamVault'
          break
        case '/tai-lieu':
          currentModule = 'Document'
          break
        case '/su-kien':
          currentModule = 'Event'
          break
        case '/huong-dan':
          currentModule = 'Instruction'
          break
        case '/lien-he':
          currentModule = 'Contact'
          break
        case '/profile':
          currentModule = 'Profile'
          break
        case '/sgk':
          currentModule = 'SchoolBookCategory'
          break
        case '/v2/virtual-test-center':
          currentModule = 'V2VirtualTestCenter'
          break
        case '/v2/resource-assignment':
          currentModule = 'V2ResourceAssignment'
          break
        case '/v2/homework-leaderboard':
          currentModule = 'V2HomeworkLeaderboard'
          break
        case '/v2/hoc-sinh':
          currentModule = 'Students'
          break
        case '/v2/course-marketplace':
          currentModule = 'V2CourseMarketplace'
          break
        case '/v2/course-marketplace/settings':
          currentModule = 'V2CmSettings'
          break
      }

      this.module = currentModule
    },

    getCenterModule(routePath) {
      if (routePath === '/v2/crm' || routePath === '/v2/crm/') {
        return 'V2CrmOverview'
      }
      const crmMap = {
        '/v2/crm/contacts': 'V2CrmContacts',
        '/v2/crm/opportunities': 'V2CrmOpportunities'
      }
      const centerMap = {
        '/v2/center/classes': 'V2CenterClasses',
        '/v2/center/students': 'V2CenterStudents',
        '/v2/center/attendance': 'V2CenterAttendance',
        '/v2/center/sessions': 'V2CenterAttendance',
        '/v2/center/timetable': 'V2CenterTimetable',
        '/v2/center/fees': 'V2CenterFees',
        '/v2/center/timesheets': 'V2CenterTimesheets',
        '/v2/center/payroll': 'V2CenterPayroll',
        '/v2/center/settings': 'V2CenterSettings'
      }
      const root = '/' + routePath.split('/').slice(1, 4).join('/')
      return crmMap[root] || centerMap[root] || null
    },

    hasCenterItem(name) {
      return this.centerTrainingItems.some((x) => x.name === name)
    },

    openEvents() {
      const first = this.eventTabs[0]
      if (first && !this.eventModules.includes(this.module)) this.open(first.name)
    },

    // School admins land on the School page; a center-only manager goes
    // straight to Cấu hình trung tâm.
    openSettings() {
      if (!this.isSchoolAdmin) return this.open('V2CenterSettings')
      const roles = this.profile.roles
      const tab = roles.includes('group_chief')
        ? 'group'
        : roles.includes('department_chief')
        ? 'department'
        : 'teachers'
      if (this.module !== 'School') this.$router.push('/truong-hoc/' + tab)
    },

    open(selectedModule) {
      if (selectedModule !== this.module) {
        this.$router.push({
          name: selectedModule
        })
      }
    },

    // An LMS class page (/lop-hoc/...) belongs to the center "Lớp học" item,
    // which replaces the LMS one.
    centerItemClass(name) {
      if (name === 'V2CenterClasses' && this.module === 'Class') return 'active'
      return this.isActive(name)
    },

    isActive(selectedModule) {
      return selectedModule === this.module ? 'active' : 'inactive'
    },

    isActiveAny(modules) {
      return modules.includes(this.module) ? 'active' : 'inactive'
    }
  }
}
</script>
<style lang="scss">
body {
  padding: safe-area-inset-top safe-area-inset-right safe-area-inset-bottom
    safe-area-inset-left;
}

.md-list-item {
  .md-list-item-content {
    min-height: 15px;
    padding: 10px 16px;
    justify-content: unset;
  }
}

.md-list-item.active {
  svg {
    fill: #1cab36 !important;
  }
}
</style>

<style lang="scss" scoped>
$active-color: #1cab36;
$active-bg: #e8f6ec;
$active-text: #15803d;
$nav-item-padding: 0px;

.scaffold {
  height: 100vh;
  position: relative;
}

/* The v2 micro-app is a full-height shell (fixed nav + scrollable body) that
   sizes via a height:100% chain. md-app-content defaults to min-height:100%,
   which is indefinite and breaks that chain, so the v2 layout collapses to
   content height. Give it a definite height on v2 routes only (the scroller
   above it is a definite-height flex child, so this resolves). */
.md-app-content.md-app-content--v2 {
  height: 100%;
  // Top bar + a body that takes the rest, keeping v2's height:100% chain.
  display: flex;
  flex-direction: column;

  .host-content {
    flex: 1;
    min-height: 0;
  }
}

// Breadcrumb on the left, user menu on the right (new design).
.host-topbar {
  position: sticky;
  top: 0;
  z-index: 5;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 64px;
  padding: 0 32px;
  background: #fff;
  border-bottom: 1px solid #e6ebe8;

  .host-topbar__crumbs {
    flex: 1;
    min-width: 0;
    font-size: 14px;

    ::v-deep .el-breadcrumb__inner,
    ::v-deep .el-breadcrumb__inner a {
      font-weight: 400;
      color: #6b7280;
    }

    ::v-deep .el-breadcrumb__inner a:hover {
      color: $active-text;
    }

    ::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner {
      font-weight: 600;
      color: #14261b;
    }
  }

  .host-topbar__end {
    margin-left: auto;
    display: flex;
    align-items: center;

    ::v-deep .md-toolbar {
      padding: 0;
      min-height: 0;
    }

    ::v-deep .home-avatar {
      max-width: 36px;

      img {
        width: 36px;
        height: 36px;
        object-fit: cover;
      }
    }
  }

  .md-icon-button {
    margin: 0 0 0 -8px;
  }
}

.md-app {
  border: none;
  height: 100%;

  .md-content {
    border: none;
    background: #f0f4f3 0% 0% no-repeat padding-box;
  }
}

.expand-menu {
  display: flex;
  padding: 18px 12px 6px 24px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  cursor: pointer;

  .expand-menu-title {
    color: #6b7280;
    // v1 pages don't load Roboto; without a fallback the label turns serif.
    font-family: Roboto, -apple-system, 'Segoe UI', Helvetica, Arial, sans-serif;
    font-size: 11.5px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    line-height: normal;
  }

  .expand-menu-icon {
    display: flex;
    align-items: center;
    width: 14px;
    height: 14px;
    opacity: 0.35;
    transform: rotate(0deg);

    svg {
      width: 14px;
      height: 14px;
    }
  }

  &:hover .expand-menu-icon {
    opacity: 0.7;
  }
}

.md-drawer {
  display: flex;
  flex-direction: column;
  width: 240px;
  max-width: calc(100vw - 125px);
  height: 100%;
  background: #fff;
  box-shadow: none;
  border: none !important;
  border-right: 1px solid #e6ebe8 !important;
  transition: width 0.3s ease;

  .md-list {
    overflow-y: auto;
    flex-grow: 1;
    padding: 0 0 8px;

    // Thin, faint scrollbar; a little stronger while the menu is hovered.
    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.08);
      border-radius: 999px;
    }

    &:hover::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.18);
    }

    // Firefox only: Chrome ignores ::-webkit-scrollbar once these are set.
    @supports (-moz-appearance: none) {
      scrollbar-width: thin;
      scrollbar-color: rgba(0, 0, 0, 0.12) transparent;
    }
  }

  // Rounded rows inset from the drawer edge; the active one is a soft green pill.
  .md-list-item {
    cursor: pointer;
    margin: 2px 12px;
    border-radius: 10px;

    ::v-deep .md-list-item-container {
      display: block;
      width: 100%;
      border-radius: 10px;
    }

    ::v-deep .md-list-item-content {
      min-height: 38px;
      padding: 0 12px;
    }

    // Our hover replaces Vue Material's grey wash.
    ::v-deep
      .md-list-item-container:not(.md-list-item-default):not(.md-list-item-expand):not([disabled]):hover {
      background-color: transparent;
    }
  }

  .nav-item-text {
    font-size: 14.5px;
    font-weight: 400;
    color: #374151;
  }

  .md-icon,
  .md-icon-font {
    width: 20px;
    min-width: 20px;
    height: 20px;
    display: flex;
    margin-right: 12px;

    svg {
      width: 20px;
      height: 20px;

      path {
        fill: #4b5563 !important;
        fill-opacity: 0.9;
      }
    }
  }

  .active-bar {
    display: none;
  }

  .md-list-item.active {
    background-color: $active-bg;

    .nav-item-text {
      color: $active-text;
      font-weight: 600;
    }

    .md-icon svg path {
      fill: $active-text !important;
      fill-opacity: 1;
    }
  }

  .md-list-item.inactive {
    background-color: transparent;

    &:hover {
      background-color: #f4f7f5;
    }
  }

  .nav-item {
    // width: 100%;
    display: flex;
    justify-content: left;
    padding: $nav-item-padding 0;
  }

  .avatar-top {
    border-bottom: none;
  }

  .md-toolbar {
    position: sticky;
    top: 0;
    display: flex;
    justify-content: left;
    width: 100%;
    min-height: 0;
    padding: 18px 8px 14px;

    .avatar {
      margin-right: 5px;
      margin-left: 10px;
      display: flex;
      justify-content: center;
      align-content: center;
      align-items: center;

      img {
        width: 36px;
        height: 36px;
        border-radius: 10px;
        object-fit: cover;
      }
    }

    .main {
      float: left;
      display: flex;
      flex-wrap: wrap;
      padding: 0;
      // width: calc(100% - 30px - 15px);
      padding-right: 10px;
      text-align: left;
      font-size: 15px;
      font-weight: 700;
      line-height: 1.25;
      color: $active-text;
    }
  }

  .drawer-version {
    list-style: none;
    padding: 20px 24px 12px;
    font-size: 11px;
    color: #9ca3af;
  }

  &.collapsed {
    width: 64px;

    // Icon-only rail.
    .md-list-item {
      margin: 2px 8px;

      ::v-deep .md-list-item-content {
        justify-content: center;
        padding: 0;
      }
    }

    .md-icon {
      margin-right: 0;
    }

    .md-toolbar .main {
      display: none;
    }

    .expand-menu {
      display: none;
    }

    .menu-toggle {
      // margin-left: auto;
      margin-left: unset !important;
      margin: 0 auto !important;
    }
  }
}

.menu-toggle {
  min-width: 30px !important;
  width: 30px !important;
  height: 30px !important;
  margin-left: 8px;
}

.md-small-show {
  display: none;
}

@media only screen and (max-width: 320px) {
}

@media only screen and (max-width: 480px) {
}

@media only screen and (max-width: 600px) {
  .md-small-show {
    display: flex;
  }

  .host-topbar {
    min-height: 56px;
    padding: 0 16px;
  }

  .md-drawer {
    width: 210px;
    max-width: 210px;
  }
}

@media only screen and (max-width: 768px) {
}

@media only screen and (max-width: 900px) {
}

@media only screen and (max-width: 1024px) {
}
</style>
